import {Component, OnInit} from '@angular/core';
import {SharedResources} from "../../../shared-resources";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {APIHelper} from "../../../apihelper";
import {Products} from "../../../models/products";
import {DeviceDetectorService} from "ngx-device-detector";

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.css']
})
export class ProductsComponent implements OnInit {

  constructor(private http: HttpClient, private deviceService: DeviceDetectorService) {
  }

  products: Products[] = [];
  numberOfProductPages: number = 0;
  currentProductPage: number = 1;
  currentProductSortColumn: string = '';
  currentProductSortDesc: boolean = false;
  currentProductSearchWord: string = '';
  isMobile: boolean = false;

  refreshDisplay() : void {
    SharedResources._isLoadingBS.next(true);
    this.http.get<any>(`${APIHelper.APIUrl}product?OrderBy=${this.currentProductSortColumn}&Desc=${this.currentProductSortDesc}&Search=${encodeURIComponent(this.currentProductSearchWord)}&Page=${this.currentProductPage}`,
      {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem('token')}`
        })
      }).subscribe(
      (response: any) => {
        if (response.total > 0) {
          if (Math.floor((response.total / 5)) + (response.total % 5 != 0 ? 1 : 0) < this.currentProductPage) {
            this.currentProductPage = 1;
            this.http.get<any>(`${APIHelper.APIUrl}product?OrderBy=${this.currentProductSortColumn}&Desc=${this.currentProductSortDesc}&Search=${encodeURIComponent(this.currentProductSearchWord)}&Page=${this.currentProductPage}`,
              {
                headers: new HttpHeaders({
                  "Content-Type": "application/json",
                  "Authorization": `Bearer ${localStorage.getItem('token')}`
                })
              }).subscribe(
              (response: any) => {
                this.products = response.content;
                this.numberOfProductPages = Math.floor((response.total / 5)) + (response.total % 5 != 0 ? 1 : 0);
                SharedResources._isLoadingBS.next(false);
              }, (error: any) => {
                alert(error.error);
                SharedResources._isLoadingBS.next(false);
              }
            );
          } else {
            this.products = response.content;
            this.numberOfProductPages = Math.floor((response.total / 5)) + (response.total % 5 != 0 ? 1 : 0);
            SharedResources._isLoadingBS.next(false);
          }
        } else {
          this.products = [];
          this.numberOfProductPages = 0;
        }
        SharedResources._isLoadingBS.next(false);
      }, (error: any) => {
        alert(error.error);
        SharedResources._isLoadingBS.next(false);
      });
  }

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobile();
    SharedResources._isLoadingBS.next(true);
    this.currentProductPage = SharedResources.currentProductPage;
    this.currentProductSortColumn = SharedResources.currentProductSortColumn;
    this.currentProductSortDesc = SharedResources.currentProductSortDesc;
    this.currentProductSearchWord = SharedResources.currentProductSearchWord;
    this.refreshDisplay();
  }

  smallFont(isMobile : any) {
    if (isMobile) {
      return {
        'font-size': 'small'
      }
    } else {
      return {};
    }
  }

  editProduct(product: Products) {
    SharedResources.currentEditProduct = product;
    SharedResources.currentScreen = 'editProduct';
    SharedResources._currentScreenBS.next('editProduct');
  }

  deleteProduct(product: Products) {
    if (confirm(`Sunteți sigur(ă) că vreți să ștergeți produsul cu codul ${product.PartNo}?`)) {
      SharedResources._isLoadingBS.next(true);
      this.http.delete<any>(
        `${APIHelper.APIUrl}product?Id=${product.Id}`,
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "Authorization": `Bearer ${localStorage.getItem('token')}`
          })
        }).subscribe(
        (response: any) => {
          this.refreshDisplay();
          SharedResources._isLoadingBS.next(false);
        }, (error: any) => {
          alert(error.error);
          SharedResources._isLoadingBS.next(false);
        }
      )
    }
  }

  changeScreenToInputProduct() {
    SharedResources.currentScreen = 'inputProduct';
    SharedResources._currentScreenBS.next('inputProduct');
  }

  refreshAfterSearch(searchWord: string) {
    SharedResources.currentProductSearchWord = searchWord;
    this.currentProductSearchWord = searchWord;
    this.refreshDisplay();
  }

  changeSortOnVendor() {
    if (this.currentProductSortColumn == 'VENDOR') {
      SharedResources.currentProductSortDesc = !SharedResources.currentProductSortDesc;
      this.currentProductSortDesc = !this.currentProductSortDesc;
    } else {
      SharedResources.currentProductSortColumn = 'VENDOR';
      this.currentProductSortColumn = 'VENDOR';
      SharedResources.currentProductSortDesc = false;
      this.currentProductSortDesc = false;
    }
    this.refreshDisplay();
  }

  changeSortOnPartNo() {
    if (this.currentProductSortColumn == 'PARTNO') {
      SharedResources.currentProductSortDesc = !SharedResources.currentProductSortDesc;
      this.currentProductSortDesc = !this.currentProductSortDesc;
    } else {
      SharedResources.currentProductSortColumn = 'PARTNO';
      this.currentProductSortColumn = 'PARTNO';
      SharedResources.currentProductSortDesc = false;
      this.currentProductSortDesc = false;
    }
    this.refreshDisplay();
  }

  changeSortOnHsCode() {
    if (this.currentProductSortColumn == 'HSCODE') {
      SharedResources.currentProductSortDesc = !SharedResources.currentProductSortDesc;
      this.currentProductSortDesc = !this.currentProductSortDesc;
    } else {
      SharedResources.currentProductSortColumn = 'HSCODE';
      this.currentProductSortColumn = 'HSCODE';
      SharedResources.currentProductSortDesc = false;
      this.currentProductSortDesc = false;
    }
    this.refreshDisplay();
  }

  changeSortOnEccn() {
    if (this.currentProductSortColumn == 'ECCN') {
      SharedResources.currentProductSortDesc = !SharedResources.currentProductSortDesc;
      this.currentProductSortDesc = !this.currentProductSortDesc;
    } else {
      SharedResources.currentProductSortColumn = 'ECCN';
      this.currentProductSortColumn = 'ECCN';
      SharedResources.currentProductSortDesc = false;
      this.currentProductSortDesc = false;
    }
    this.refreshDisplay();
  }

  changeSortOnGreutateNeta() {
    if (this.currentProductSortColumn == 'GREUTATENETA') {
      SharedResources.currentProductSortDesc = !SharedResources.currentProductSortDesc;
      this.currentProductSortDesc = !this.currentProductSortDesc;
    } else {
      SharedResources.currentProductSortColumn = 'GREUTATENETA';
      this.currentProductSortColumn = 'GREUTATENETA';
      SharedResources.currentProductSortDesc = false;
      this.currentProductSortDesc = false;
    }
    this.refreshDisplay();
  }

  changeSortOnCategorieTimbruVerde() {
    if (this.currentProductSortColumn == 'CATEGORIETIMBRUVERDE') {
      SharedResources.currentProductSortDesc = !SharedResources.currentProductSortDesc;
      this.currentProductSortDesc = !this.currentProductSortDesc;
    } else {
      SharedResources.currentProductSortColumn = 'CATEGORIETIMBRUVERDE';
      this.currentProductSortColumn = 'CATEGORIETIMBRUVERDE';
      SharedResources.currentProductSortDesc = false;
      this.currentProductSortDesc = false;
    }
    this.refreshDisplay();
  }

  changeSortOnTaraOrigine() {
    if (this.currentProductSortColumn == 'TARAORIGINE') {
      SharedResources.currentProductSortDesc = !SharedResources.currentProductSortDesc;
      this.currentProductSortDesc = !this.currentProductSortDesc;
    } else {
      SharedResources.currentProductSortColumn = 'TARAORIGINE';
      this.currentProductSortColumn = 'TARAORIGINE';
      SharedResources.currentProductSortDesc = false;
      this.currentProductSortDesc = false;
    }
    this.refreshDisplay();
  }

  goToFirstPage() {
    SharedResources.currentProductPage = 1;
    this.currentProductPage = 1;
    this.refreshDisplay();
  }

  goToPrevPage() {
    if (this.currentProductPage == 1) {
      this.goToLastPage()
    } else {
      SharedResources.currentProductPage -= 1;
      this.currentProductPage -= 1;
      this.refreshDisplay();
    }
  }

  goToNextPage() {
    if (this.currentProductPage == this.numberOfProductPages) {
      this.goToFirstPage()
    } else {
      SharedResources.currentProductPage += 1;
      this.currentProductPage += 1;
      this.refreshDisplay();
    }
  }

  goToLastPage() {
    SharedResources.currentProductPage = this.numberOfProductPages;
    this.currentProductPage = this.numberOfProductPages;
    this.refreshDisplay();
  }
}
